import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import posthog from 'posthog-js';

const PostHogPageview = () => {
  const location = useLocation();

  useEffect(() => {
    // $pageview is a PostHog reserved event — fires directly, not through trackEvent (which would also send to GA4)
    posthog.capture('$pageview', {
      $current_url: window.location.href,
    });
  }, [location.pathname]);

  return null;
};

export default PostHogPageview;
